module.exports = __webpack_public_path__ + "img/shang.5fe5db31.png";